import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './AppBody.scss'

class AppBody extends React.Component {
	componentWillReceiveProps() {
		this.bodyDiv.scrollTop = 0
	}
	render() {
		const { children, noScroll } = this.props
		return (
			<div
				styleName={noScroll ? 'body-no-scroll' : 'body'}
				ref={body => {
					this.bodyDiv = body
				}}
			>
				{children}
			</div>
		)
	}
}

AppBody.propTypes = {
	children: React.PropTypes.node
}

export default CSSModules(AppBody, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/AppBody/AppBody.js